import { Box, Grid } from "@mui/material";
import { navigationData as NavigationData, PaginationObj, SortingObj } from "../types";
import { useEffect, useState } from "react";
import { AlternativeAssetAllocationRes, FundHouseApiRes, TopFiveApiRes, topFiveTableObj } from "../../../redux-store/types/alternative";
import { useDispatch, useSelector } from "react-redux";
import { AlternateAssetAllocationApi, FundHouseApi, topfiveApi } from "../../../redux-store/actions/alternates";
import { Distribution } from "../mutualFund/OverView";
import AlternativeAssetPieChart from "./component/AlternativeAssetPieChart";
import AlternativeAssetTable from "./component/AlternativeAssetTable";
import FundHouse from "./component/FundHouse";
import TopFiveComponent from "./component/TopFiveComponet";
import { RootStateType } from "../../../redux-store/reducers";
import { useHistory } from "react-router";
import { USER_ROLES } from "../../../utils/constant";
import { calculateOthersInPieChart } from "../../../utils/utilityFunctions";


export default function AlternatesOverview(props: NavigationData): JSX.Element {
    const { clientCode } = props
    const dispatch = useDispatch()
    const { id: { investorClientId, iwappRmId }, selectedPortfiolio: { selectedPortfolio }, auth: { role = '' } } = useSelector((state: RootStateType) => state)
    const { investorRmId = "" } = useSelector((state: RootStateType) => state.sessionData)
    const history = useHistory()
    const { pathname } = history.location

    const IsInvestor = pathname.split('/').filter(item => item !== '')[0] === 'investor-dashboard'
    //state
    const [isLoading, setIsLoading] = useState(false)
    const [assetsAllocation, setAssetsAllocation] = useState<AlternativeAssetAllocationRes>({} as AlternativeAssetAllocationRes)
    const [fundHouseData, setFundHouseData] = useState<FundHouseApiRes>({} as FundHouseApiRes)
    const [topFiveData, setTopFiveData] = useState<Array<topFiveTableObj>>([] as Array<topFiveTableObj>)
    const [bottomFiveData, setBottomFiveData] = useState<Array<topFiveTableObj>>([] as Array<topFiveTableObj>)
    const [assetAllocationFilter, setAssetAllocationFilter] = useState(1)

    const [fundHousesortingObj, setFundHouseSortingObj] = useState<SortingObj>({
        order: "desc",
        orderBy: ""
    })

    const [fundHousePage, setFundHousePage] = useState<PaginationObj>({
        currentPage: 1,
        rowsPerPage: 5,
        totalRows: 0
    })


    useEffect(() => {
        if (iwappRmId || investorRmId) fetchAll()
    }, [iwappRmId, investorRmId])

    const fetchAll = async () => {
        //loading start
        setIsLoading(true)

        await Promise.allSettled([assetsAllocationApi(), fundHouse(), topFive(true), topFive(false)])
        //loading end
        setIsLoading(false)

    }

    const assetsAllocationApi = async () => {
        const payload = {
            "rmId": pathname.includes('product') ? `${iwappRmId}` : `${investorRmId}`,
            "sortItem": "category",
            "order": "asc",
            "assetGroup": "AL",
            "clientCode": ![USER_ROLES.INVESTOR].includes(role) ? clientCode : investorClientId,
            portfolioId: selectedPortfolio.value,
        }
        const res = (await dispatch(AlternateAssetAllocationApi(payload)) as unknown) as AlternativeAssetAllocationRes
        if (res.isSuccess) {
            setAssetsAllocation({ ...res, result: { ...res?.result, categoryWiseDistribution: { ...calculateOthersInPieChart(res?.result?.categoryWiseDistribution,) } } })
        }
    }

    const fundHouse = async (currentPage = 1, rowsPerPage = 5, sortItem = "fundHouseName", order = "asc") => {
        const payload = {
            "rmId": pathname.includes('product') ? `${iwappRmId}` : `${investorRmId}`,
            "sortItem": sortItem,
            "order": order,
            "assetGroup": "AL",
            "currentPage": currentPage,
            "rowsPerPage": rowsPerPage,
            "clientCode": ![USER_ROLES.INVESTOR].includes(role) ? clientCode : investorClientId,
            portfolioId: selectedPortfolio.value,
        }
        const res = (await dispatch(FundHouseApi(payload)) as unknown) as FundHouseApiRes
        if (res.isSuccess) {
            setFundHouseData(res)
            setFundHousePage({
                currentPage: currentPage,
                rowsPerPage: rowsPerPage,
                totalRows: 0 //TODO
            })
        }
    }



    const topFive = async (isTop = false) => {

        const payload = {
            "rmId": pathname.includes('product') ? `${iwappRmId}` : `${investorRmId}`,
            "assetGroup": "AL",
            "clientCode": ![USER_ROLES.INVESTOR].includes(role) ? clientCode : investorClientId,
            portfolioId: selectedPortfolio.value || '',
            isTop //FALSE MEANS BOTTOM FIVE
        }
        const res = (await dispatch(topfiveApi(payload)) as unknown) as TopFiveApiRes
        // console.log(res)
        if (res.isSuccess) {
            if (isTop) setTopFiveData(res.result.topSchemes.data)
            else setBottomFiveData(res.result.topSchemes.data)
        }

    }

    const fundHouseHandlePageChange = (event: any, page: number) => {
        // console.log("page", page)
        setFundHousePage({ ...fundHousePage, currentPage: page + 1 })
        fundHouse(page + 1, fundHousePage.rowsPerPage, fundHousesortingObj.orderBy, fundHousesortingObj.order)
    }

    const fundHouseHandleRowChange = (event: any, row: number) => {
        // console.log("row", event.target.value)
        setFundHousePage({ ...fundHousePage, rowsPerPage: event.target.value })
        fundHouse(fundHousePage.currentPage, event.target.value, fundHousesortingObj.orderBy, fundHousesortingObj.order)
    }

    const handleFundHouseTableSorting = (id: "categoryType" | "investedValue" | "marketValue" | "gainLoss", orderType: "asc" | "desc") => {
        // console.log("id", id, "orderType", orderType)
        setFundHouseSortingObj({ order: orderType, orderBy: id })
        fundHouse(fundHousePage.currentPage, fundHousePage.rowsPerPage, id, orderType)
    }


    return (
        <Box>
            <Grid container spacing={2}>
                <Grid item lg={6} md={12} sx={{ width: '100%' }} sm={12}>
                    <AlternativeAssetPieChart
                        completeData={assetsAllocation}
                        isLoading={isLoading}
                        clientCode={clientCode ?? ""}
                    />
                </Grid>
                <Grid item lg={6} md={12} sm={12} sx={{ width: '100%' }}>
                    <AlternativeAssetTable isLoading={isLoading} completeData={assetsAllocation} />
                </Grid>
                <Grid item lg={12} md={12} sm={12} sx={{ width: '100%' }}>
                    <FundHouse isLoading={isLoading} completeData={fundHouseData.result || []} onPageChange={fundHouseHandlePageChange} sortingObj={fundHousesortingObj} handletableSorting={handleFundHouseTableSorting} totalPage={fundHouseData.totalLength} onRowsPerPageChange={fundHouseHandleRowChange} paginationObj={fundHousePage} />
                </Grid>
                <Grid item lg={12} md={12} sm={12} sx={{ width: '100%' }}>
                    <TopFiveComponent title="Top 5 Performers" isLoading={isLoading} completeData={topFiveData || []} />
                </Grid>
                <Grid item lg={12} md={12} sm={12} sx={{ width: '100%' }}>
                    <TopFiveComponent title="Bottom 5 Performers" isLoading={isLoading} completeData={bottomFiveData || []} />
                </Grid>
            </Grid>
        </Box>
    )
}

